import { useCallback, useEffect, useMemo, useReducer } from 'react';

import { FormContext, FormContextDefinition, FormStatusDefinition } from './context';

export default function FormStatusProvider({ children }) {
  const initialState = useMemo(() => new FormStatusDefinition, [])

  const [status, setStatus] = useReducer((prev, next) => ({ ...prev, ...next }), initialState)

  useEffect(() => () => setStatus(initialState), [initialState])

  const handleStatus = useCallback(status => setStatus(status), [])

  const value = new class extends FormContextDefinition {
    status = status
    handleStatus = handleStatus
  }

  return <FormContext.Provider value={value}>
    {children}
  </FormContext.Provider>
}
